module.exports = __webpack_public_path__ + "static/img/Spencer-Leniu.2dae30c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Spencer-Leniu.jpg
// module id = gvTW
// module chunks = 0